import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 5.29a7.02 7.02 0 0 0-4.63 4.458M14 5.29A7.02 7.02 0 0 1 18.71 10m-.043 4.14A7.02 7.02 0 0 1 14 18.71m-4 0A7.02 7.02 0 0 1 5.29 14"
      stroke={color}
      strokeWidth="2"
    />
    <circle cx="12" cy="5" r="2" stroke={color} strokeWidth="2" />
    <circle cx="12" cy="19" r="2" stroke={color} strokeWidth="2" />
    <circle cx="5" cy="12" r="2" stroke={color} strokeWidth="2" />
    <circle cx="19" cy="12" r="2" stroke={color} strokeWidth="2" />
  </svg>
);
